/* PACKCRAFT MENU */
document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper === 'undefined') return;

  var swipers = document.querySelectorAll('.section--compare .compare-swiper');

  swipers.forEach(function (root) {
    var paginationEl = root.querySelector('.compare-swiper__pagination');
    var swiperInstance;

    function initSwiper() {
      var isDesktop = window.innerWidth >= 1500;

      // destruir no desktop
      if (isDesktop && swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
        return;
      }

      // criar no mobile/tablet
      if (!isDesktop && !swiperInstance) {
        swiperInstance = new Swiper(root, {
          slidesPerView: 1,
          spaceBetween: 12,
          watchOverflow: true,
          grabCursor: true,
          rewind: true,
            pagination: {
                el: ".swiper-pagination"
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true
            },
            autoplay: {
                disableOnInteraction: true
            },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 16
            },
            1200: {
              slidesPerView: 2.5,
              spaceBetween: 20
            }
          }
        });
      }
    }

    initSwiper();
    window.addEventListener('resize', initSwiper);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".packcraft-toggle");
  const target = document.querySelector(".packraft-comparison-simple");
  const drawer = document.querySelector("#Details-menu-drawer-container");

  if (!triggers.length || !target) return;

  // Detecta mobile
  const isMobile = () => window.innerWidth <= 991;

  function closeDrawer() {
    setTimeout(function () {
      if (drawer) {
        drawer.removeAttribute("open");
        drawer.classList.remove("menu-opening");
        document.body.classList.remove("overflow-hidden-tablet");

        const section = document.querySelector(".shopify-section");
        if (section) section.classList.remove("menu-open");
      }
    }, 0);
  }

  triggers.forEach(function (trigger) {

    // MOBILE = CLICK
    trigger.addEventListener("click", function (e) {
      if (!isMobile()) return;

      e.preventDefault();
      e.stopPropagation();

      target.classList.toggle("active");

      closeDrawer();
    });

    // DESKTOP = HOVER
    trigger.addEventListener("mouseenter", function () {
      if (isMobile()) return;

      target.classList.add("active");
    });

    trigger.addEventListener("mouseleave", function () {
      if (isMobile()) return;

      setTimeout(() => {
        if (!target.matches(":hover")) {
          target.classList.remove("active");
        }
      }, 100);
    });
  });

  // Mantém aberto ao passar mouse no conteúdo
  target.addEventListener("mouseenter", function () {
    if (isMobile()) return;

    target.classList.add("active");
  });

  target.addEventListener("mouseleave", function () {
    if (isMobile()) return;

    target.classList.remove("active");
  });

  // Mobile: impede fechamento ao clicar dentro
  target.addEventListener("click", function (e) {
    if (!isMobile()) return;

    e.stopPropagation();
  });

  // Mobile: fecha clicando fora
  document.addEventListener("click", function () {
    if (!isMobile()) return;

    target.classList.remove("active");
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(".links-filter a");
  const currentUrl = window.location.href;

  links.forEach(link => {
    if (currentUrl.includes(link.getAttribute("href"))) {
      link.classList.add("active");
    }
  });
});

document.querySelectorAll(".links-filter a").forEach(link => {
  link.addEventListener("click", function(e) {
    e.preventDefault();

    const url = this.href;

    // Atualiza URL no navegador
    window.history.pushState({}, "", url);

    // Atualiza active
    document.querySelectorAll(".links-filter a").forEach(l => l.classList.remove("active"));
    this.classList.add("active");

    // Faz requisição AJAX
    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // pega a nova grid
        const newGrid = doc.querySelector("#product-grid");
        const currentGrid = document.querySelector("#product-grid");

        if (newGrid && currentGrid) {
          currentGrid.innerHTML = newGrid.innerHTML;
        }
      })
      .catch(err => console.error("Erro ao carregar produtos:", err));
  });
});

document.addEventListener('click', (e) => {
  const filterBtn = e.target.closest('.filter');
  if (filterBtn) {
      const filterContainer = document.querySelector('.links-filter');
      filterContainer?.classList.toggle('visible');
      return;
  }
});

//PAGINA ADVENTURES
function initializeAdventureSwipers() {
  const sliders = document.querySelectorAll('.adventure-swiper');

  sliders.forEach((slider) => {
    if (slider.classList.contains('swiper-initialized')) return;

    const totalSlides =
      slider.querySelectorAll('.swiper-slide').length;

    new Swiper(slider, {
      loop: totalSlides > 1,
      slidesPerView: totalSlides > 2 ? 1.2 : 1,
      centeredSlides: totalSlides > 4,
      spaceBetween: 20,
      speed: 1200,
      grabCursor: true,
      observer: true,
      observeParents: true,

      autoplay: totalSlides > 1 ? {
        delay: 4000,
        disableOnInteraction: false,
      } : false,

      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },

    });
  });
}

function initializeAdventureSwipers() {
  const sliders = document.querySelectorAll('.adventure-single-swiper');

  sliders.forEach((slider) => {
    if (slider.classList.contains('swiper-initialized')) return;

    const totalSlides =
      slider.querySelectorAll('.swiper-slide').length;

    new Swiper(slider, {
      loop: totalSlides > 1,
      slidesPerView: totalSlides > 2 ? 1.5 : 1,
      centeredSlides: totalSlides > 3,
      spaceBetween: 20,
      speed: 1200,
      grabCursor: true,
      observer: true,
      observeParents: true,

      autoplay: totalSlides > 1 ? {
        delay: 4000,
        disableOnInteraction: false,
      } : false,

      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },

    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
    const button = document.getElementById('load-more');
    if (!button) return;
    button.addEventListener('click', () => {
        const hiddenItems = document.querySelectorAll('.adventure-card.is-hidden');
        for (let i = 0; i < 4; i++) {
            if (hiddenItems[i]) {
                hiddenItems[i].classList.remove('is-hidden');
            }
        }
        if (document.querySelectorAll('.adventure-card.is-hidden').length === 0) {
            button.style.display = 'none';
        }
    });
});


// POP UPS
document.addEventListener('DOMContentLoaded', () => {

    const popup = document.querySelector('.popup-side');
    const overlay = document.querySelector('.popup-overlay');
    const popupContent = document.getElementById('popup-content');

    document.querySelectorAll('.open-popup').forEach(button => {

        button.addEventListener('click', () => {

            const type = button.dataset.popup;

            const template = document.querySelector(
                `.popup-template[data-template="${type}"]`
            );

            popupContent.innerHTML = template.innerHTML;

            popup.classList.add('active');
            overlay.classList.add('active');

            document.body.style.overflow = 'hidden';

        });

    });

    function closePopup() {

        popup.classList.remove('active');
        overlay.classList.remove('active');

        document.body.style.overflow = '';

    }

    document.addEventListener('click', (e) => {

        if (
            e.target.classList.contains('close-popup') ||
            e.target.classList.contains('popup-overlay')
        ) {
            closePopup();
        }

    });

});

